import {
  AppFooter_v2 as AppFooter,
  Button_v2 as Button,
  Container_v2 as Container,
  Typography,
  TypographyVariantsEnum,
  useEvent,
  IconCalendarNew,
} from '@mindly/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppointment } from 'src/hooks/useAppointment/useAppointment';
import { useIsKeyBoardShown } from 'src/hooks/useIsKeyboardShown';

type SubscriptionContinueTherapyFeatureProps = {
  specialistId: string;
  specialistName: string;
  onContinueTherapy: () => void;
  onClose: () => void;
};

const SubscriptionContinueTherapyFeature = ({
  specialistId,
  specialistName,
  onContinueTherapy,
  onClose,
}: SubscriptionContinueTherapyFeatureProps) => {
  const { t } = useTranslation('reviews');
  const isKeyboardShown = useIsKeyBoardShown();
  const { pushToAppointmentPage } = useAppointment();
  const [isLoading, setIsLoading] = useState(false);

  const handleBooking = useEvent(async () => {
    try {
      if (!specialistId) return;
      onContinueTherapy?.();
      await setIsLoading(true);
      await pushToAppointmentPage(specialistId);
      setIsLoading(false);
      onClose?.();
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  });

  return (
    <>
      <Container>
        <div className="flex flex-col h-full justify-center">
          <div className="flex flex-col justify-center items-center gap-y-3">
            <IconCalendarNew />
            <Typography align="center" variant={TypographyVariantsEnum.Title24Semi}>
              {t('subscription.offer.title', {
                specialistFullName: specialistName,
              })}
            </Typography>
            <Typography
              align="center"
              className="!text-typography-typography-primary/50"
              variant={TypographyVariantsEnum.Text14Regular}
            >
              {t('subscription.offer.description')}
            </Typography>
          </div>
        </div>
      </Container>
      <AppFooter transparent bottomSaveArea={!isKeyboardShown} className="!pb-4">
        <Button size="large" fullWidth onClick={handleBooking} isLoading={isLoading}>
          {t('subscription_offer_button')}
        </Button>
      </AppFooter>
    </>
  );
};

export default SubscriptionContinueTherapyFeature;
